(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vslf-back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vslf-restock')) {
    customElements.define('vslf-restock', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-restock-variants]').textContent);
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.trigger = this.querySelector('.vslf-restock__trigger');
        this.status = this.querySelector('.vslf-restock__status');
        this.submit = this.form.querySelector('[type="submit"]');
        this.submitLabel = this.submit.textContent;
        this.scope = document.getElementById('MainProduct-' + this.dataset.sectionId) || this.closest('.shopify-section');
        this.onChange = event => {
          if (event.target.closest('variant-selects, secondary-variant-select, [name="id"]')) {
            queueMicrotask(() => this.sync());
          }
        };
        this.scope?.addEventListener('change', this.onChange);
        this.trigger.addEventListener('click', () => this.open());
        this.querySelector('.vslf-restock__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.form.addEventListener('submit', event => this.subscribe(event));
        this.sync();
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.onChange);
        this.initialized = false;
      }
      selectedVariant() {
        const picker = document.getElementById('variant-selects-' + this.dataset.sectionId);
        const options = picker ? Array.from(picker.querySelectorAll('.product-form__input')).map(group => group.querySelector('input[type="radio"]:checked, select')?.value) : [];
        if (options.length) return this.variants.find(variant => variant.options.every((value, index) => value === options[index]));
        const id = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value || this.dataset.selectedId;
        return this.variants.find(variant => String(variant.id) === String(id));
      }
      sync() {
        const variant = this.selectedVariant();
        this.hidden = !variant || variant.available;
        if (this.dialog.open && (!variant || variant.available || variant.id !== this.activeVariant?.id)) this.dialog.close();
      }
      open() {
        const variant = this.selectedVariant();
        if (!variant || variant.available) return;
        if (!this.pending) {
          this.activeVariant = variant;
          this.form.hidden = false;
          this.status.hidden = true;
          this.status.removeAttribute('data-error');
          this.querySelector('.vslf-restock__size').textContent = this.dataset.sizeLabel.replace('[size]', variant.title);
        }
        this.dialog.showModal();
        this.form.querySelector('input').focus();
      }
      async subscribe(event) {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity() || !this.activeVariant) return;
        const variant = this.activeVariant;
        const email = this.form.querySelector('input').value.trim();
        this.pending = true;
        this.submit.disabled = true;
        this.submit.textContent = this.dataset.sending;
        this.status.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.dataset.companyId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-10-15' },
            signal: controller.signal,
            body: JSON.stringify({ data: {
              type: 'back-in-stock-subscription',
              attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } } }
            } })
          });
          if (response.status !== 202) throw new Error('Restock request failed');
          this.form.hidden = true;
          this.form.reset();
          this.status.removeAttribute('data-error');
          this.status.textContent = this.dataset.success;
        } catch (error) {
          this.status.setAttribute('data-error', '');
          this.status.textContent = this.dataset.error;
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.submit.disabled = false;
          this.submit.textContent = this.submitLabel;
          this.status.hidden = false;
          if (this.dialog.open) this.status.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
